import moment from "moment";

/**
 * Utility functions for formatting dates and times
 */

/**
 * Formats a date string into a local date string
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
  if (!dateString) return "";
  const m = moment(dateString);
  return m.isValid() ? m.format("DD/MM/YYYY") : "";
};

/**
 * Formats a date and optional time into a readable string
 * @param {string|Date} date - The date to format
 * @param {string} [time] - Optional time string
 * @returns {string} Formatted date and time string
 */
export const formatDateTime = (date, time) => {
  if (!date) return "";
  const formattedDate = formatDate(date);
  return time ? `${formattedDate} at ${time}` : formattedDate;
};

/**
 * Formats a date string into a local date input string (YYYY-MM-DD)
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date input string
 */
export const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  if (typeof dateString === "string" && dateString.length >= 10) {
    const datePart = dateString.substring(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
  }
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch (e) {
    return "";
  }
};
